import { createContext, Context } from 'react';

const PreferenceContext: Context<{preferenceID: number, setPreferenceID: (id: number) => void}> = createContext({
  preferenceID: 0,
  setPreferenceID: (id: number) => {},
});

export default PreferenceContext;
